import React from "react";
import { BasicFieldProps } from "./props";
import classNames from "classnames";

export const Checkbox = ({ field, fieldId }: BasicFieldProps): JSX.Element => {
  const { isRequired, cssClass, id, choices, layoutGridColumnSpan } = field;
  const options = JSON.parse(choices);
  // Gravity Form field ID ~ name.
  const gfName = `input_${id}`;
  return (
    <div
      className={classNames({
        [cssClass]: cssClass,
        required: isRequired,
      })}
      style={{ "--col-width": layoutGridColumnSpan } as React.CSSProperties}
    >
      {options &&
        options.map((option, index) => (
          <div key={index}>
            <input
              // index starts from 1 for gravity form
              name={`${gfName}_${index + 1}`}
              id={`${fieldId}-${index}`}
              type="checkbox"
              value={option.value}
            />
            <label htmlFor={`${fieldId}-${index}`} className="checkbox">
              {option.text}
            </label>
          </div>
        ))}
    </div>
  );
};
